
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AmazonSettlementReportItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AmazonSettlementReportItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settlementId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settlementStartDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settlementEndDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settlementDepositDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settlementTotalAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amazonOrderReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shipmentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketplaceName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderItemCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sku"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exceptionReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archived"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":545}};
    doc.loc.source = {"body":"fragment AmazonSettlementReportItemFragment on AmazonSettlementReportItem {\n  id\n  uuid\n  concurrencyVersion\n  createdAt\n  createdBy\n  updatedBy\n  updatedAt\n  settlementId\n  settlementStartDate\n  settlementEndDate\n  settlementDepositDate\n  settlementTotalAmount\n  transactionType\n  amazonOrderReference\n  orderReference\n  adjustmentId\n  shipmentId\n  marketplaceName\n  amount\n  amountType\n  amountDescription\n  fulfillmentId\n  postedDate\n  orderItemCode\n  orderItemId\n  adjustmentItemId\n  sku\n  quantity\n  currency\n  exceptionReason\n  archived\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AmazonSettlementReportItemFragment"] = oneQuery(doc, "AmazonSettlementReportItemFragment");
        
